import { apiRequest } from "../lib/apiClient";
import type { DashboardSummaryOut } from "./types";
import type { DateRangeQuery } from "./reportsApi";

/** `GET /reports/dashboard-summary` — data source for the new simplified-dashboard home
 * page (business-owner walkthrough follow-up). Backend defaults `date_from` to the
 * trailing 365 days when omitted. */
export async function getDashboardSummary(accessToken: string, range: DateRangeQuery = {}): Promise<DashboardSummaryOut> {
  return apiRequest<DashboardSummaryOut>("/reports/dashboard-summary", {
    accessToken,
    query: { branch_id: range.branchId, date_from: range.dateFrom, date_to: range.dateTo },
  });
}
